import {Counter, QueueItem} from './types';

export class RealCounter implements Counter {
    id: number;
    inited = false;
    disabled = false;
    queue: QueueItem[];

    constructor(id: number) {
        this.id = id;
        this.queue = [];

        if (this.getInstance()) {
            this.disabled = this.isDisabled();
            this.inited = !this.disabled;
        } else {
            this.attachCallback();
        }
    }

    hit(...args: unknown[]) {
        this.callOrQueueMethod('hit', args);
    }

    params(...args: unknown[]) {
        this.callOrQueueMethod('params', args);
    }

    userParams(...args: unknown[]) {
        this.callOrQueueMethod('userParams', args);
    }

    reachGoal(...args: unknown[]) {
        this.callOrQueueMethod('reachGoal', args);
    }

    private callOrQueueMethod(method: QueueItem['method'], args: unknown[]) {
        if (this.disabled) {
            return;
        }

        if (this.inited) {
            const instance = this.getInstance();
            if (instance && instance[method]) {
                instance[method](...args);
            }
        } else {
            this.queue.push({method, args});
        }
    }

    private attachCallback() {
        (window as any)[`yaCounter${this.id}Callback`] = () => {
            this.disabled = this.isDisabled();
            this.inited = !this.disabled;

            if (this.inited && this.queue.length > 0) {
                this.queue.forEach(({method, args}) => this[method](...args));
                this.queue = [];
            }
        };
    }

    private getInstance() {
        return window[`yaCounter${this.id}` as keyof Window] as unknown as Counter;
    }

    private isDisabled() {
        return (
            (window[`disableYaCounter${this.id}` as keyof Window] as unknown as Boolean) === true
        );
    }
}
